module.exports = __webpack_public_path__ + "media/images/og-pygmalion-7cc61fdac104177c6afd6ada47345ebb.jpg";